export default {
      id: "spinner-infinity-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "img/icons.e72ac2e3.svg#spinner-infinity",
      toString: function () {
        return this.url;
      }
    }